import { USER_ROLES } from '@/config/permissions'
import { useAuthStore } from '@/store/useAuthStore'
import { useSessionUiStore } from '@/store/useSessionUiStore'

/**
 * Onglets sidebar masqués pour la team active — dérivé une fois depuis GET /auth/session.
 * Même pattern que useIsEsn (store sessionUi, pas de context React dédié).
 */
export function useDisabledSidebarItems(): string[] {
  const disabledSidebarItems = useSessionUiStore((state) => state.disabledSidebarItems)
  const menuReady = useSessionUiStore((state) => state.menuReady)
  const globalRole = useAuthStore((state) => state.globalRole)

  const appliesToTeamMenu =
    globalRole === USER_ROLES.TEAM_ADMIN ||
    globalRole === USER_ROLES.TEAM_MEMBER ||
    globalRole === USER_ROLES.FREELANCER

  if (!appliesToTeamMenu || !menuReady) return []

  return disabledSidebarItems
}
